import { render, staticRenderFns } from "./InputBlock.vue?vue&type=template&id=31876e9a&scoped=true&"
import script from "./InputBlock.vue?vue&type=script&lang=js&"
export * from "./InputBlock.vue?vue&type=script&lang=js&"
import style0 from "./InputBlock.vue?vue&type=style&index=0&id=31876e9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31876e9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev/tafelgasten.outlawz.dev/web/app/themes/tafelgasten/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31876e9a')) {
      api.createRecord('31876e9a', component.options)
    } else {
      api.reload('31876e9a', component.options)
    }
    module.hot.accept("./InputBlock.vue?vue&type=template&id=31876e9a&scoped=true&", function () {
      api.rerender('31876e9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/Checkout/Components/Form/InputBlock.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/Checkout/Components/Form/InputBlock.vue
// module id = 289
// module chunks = 0